// Shared dashboard layout / palette / widget defaults.
// Extracted from DashboardPage.jsx for reuse + maintainability.

export const THEMES = {
  default: { bg: 'from-[#FDFBF7] to-[#FFF8F0]', card: 'border-border', accent: 'text-primary' },
  dark: { bg: 'from-stone-900 to-stone-800', card: 'border-stone-700 bg-muted/50 text-white', accent: 'text-orange-400' },
  blue: { bg: 'from-blue-50 to-indigo-50', card: 'border-info/30', accent: 'text-info' },
  green: { bg: 'from-emerald-50 to-teal-50', card: 'border-success/30', accent: 'text-success' },
};

export const PIE_COLORS = ['#F5841F', '#22C55E', '#0EA5E9', '#EF4444', '#F59E0B', '#8B5CF6'];

export const DEFAULT_WIDGETS = {
  stats: true, charts: true, quickActions: true, budgetAlerts: true, recentTransactions: true,
  cashBank: true, paymentMode: true, spending: true, dues: true, branchDues: true,
  vatSummary: true, vatLiability: true, lowStock: true, peakHours: true, customerInsights: true, profitTrend: true,
  stockAlertTrends: true, dunningScorecard: true, complianceHealth: true, branchTiles: true,
};

export const WIDGET_OPTIONS = [
  { key: 'stats', labelKey: 'widget_stats', descKey: 'widget_desc_stats' },
  { key: 'charts', labelKey: 'widget_charts', descKey: 'widget_desc_charts' },
  { key: 'quickActions', labelKey: 'Quick Actions', descKey: 'Role-based shortcuts' },
  { key: 'budgetAlerts', labelKey: 'Budget Alerts', descKey: 'Active budget threshold warnings' },
  { key: 'recentTransactions', labelKey: 'Recent Transactions', descKey: 'Latest sales & expenses' },
  { key: 'cashBank', labelKey: 'widget_cash_bank', descKey: 'widget_desc_cash' },
  { key: 'paymentMode', labelKey: 'widget_payment_mode', descKey: 'widget_desc_payment' },
  { key: 'spending', labelKey: 'widget_spending', descKey: 'widget_desc_spending' },
  { key: 'dues', labelKey: 'widget_dues', descKey: 'widget_desc_dues' },
  { key: 'branchDues', labelKey: 'widget_branch_dues', descKey: 'widget_desc_branch' },
  { key: 'branchTiles', labelKey: 'Branch Tiles', descKey: 'Per-branch owed/owe chip + nightly auto-net switch' },
  { key: 'vatSummary', labelKey: 'widget_vat', descKey: 'widget_desc_vat' },
  { key: 'vatLiability', labelKey: 'VAT Liability Snapshot', descKey: 'Net VAT owed to ZATCA at a glance' },
  { key: 'lowStock', labelKey: 'AI: Low Stock Alerts', descKey: 'Items predicted to run low' },
  { key: 'peakHours', labelKey: 'AI: Peak Hours', descKey: 'Optimal staffing insights' },
  { key: 'customerInsights', labelKey: 'AI: Customer CLV', descKey: 'Top value customers' },
  { key: 'profitTrend', labelKey: 'AI: Profit Analysis', descKey: 'Daily profit decomposition' },
  { key: 'stockAlertTrends', labelKey: 'Stock Alert Trends', descKey: 'Historical stock alert frequency' },
  { key: 'dunningScorecard', labelKey: 'Dunning Scorecard', descKey: 'Effectiveness of credit reminders' },
  { key: 'complianceHealth', labelKey: 'Compliance Health Score', descKey: 'Reminders + HR docs + tax submissions roll-up' },
];
